@if (resource()) {
@if (hasImage()) {
<div class="resource-tile__image-wrapper">
  <cx-media [alt]="resource().source.name" [container]="{url: resource().source.logo}" [title]="resource().source.name"
    class="tile-img">
  </cx-media>
</div>
}

<div [class.pt-4]="hasImage() && imageTop()" [class.pt-5]="!hasImage() || !imageTop()"
  class="d-flex flex-grow-1 flex-column px-4 pb-5">

  @if (hasLabel()) {
  <div class="body--xxs">{{ resource().label }}</div>
  }

  <div [class.mt-2]="hasLabel() && (hasImage() || hasDescription())" [class.mt-3]="hasLabel() && !hasImage() && !hasDescription()"
    class="heading__medium--{{ headlineSize() }}">
    {{ resource().text }}
  </div>

  @if (hasDescription() && !hasImage()) {
  <div class="w-100 separator pt-4"></div>
  }

  @if (hasDescription()) {
  <div [class.mt-3]="hasImage()" [class.mt-4]="!hasImage()" class="body--xxs">
    {{ resource().description }}
  </div>
  }

  <dcp-product-type-display class="mt-auto" [type]="resource().type" [value]="resource().value">
  </dcp-product-type-display>
</div>
}
